export enum AuthTypesEnum {
  REGISTER = 'register',
  LOGIN = 'login'
}

export enum PaymentMethodType {
  CreditCard = 'cc',
  Mbway = 'mbw',
  Multibanco = 'mb',
  Wallet = 'wallet_pay'
}

export enum EmptyStateOptions {
  NoProducts = 1,
  NoCategories = 2,
  NoRatings = 3,
  NoProductsRefresh = 5,
  NoCompare = 6,
  ErrorLoadingProduct = 7,
  NoCategoryProducts = 8,
  NoSearchFound = 9,
  EmptyBasket = 10,
  NoFavourites = 11,
  NoOrders = 12,
  OrderNotFound = 13,
  NoPromotion = 14
}

export enum TypeNumber {
  ProductPage = 1,
  Modal = 2
}

export enum ButtonType {
  Primary = 1,
  WhiteGreen = 2,
  Disabled = 3,
  WhiteGray = 4,
  Gray = 5,
  Green = 6,
  GreenLight = 7
}

export enum InputType {
  EMAIL = 'email',
  PASSWORD = 'password',
  TEXT = 'text',
  TEL = 'tel',
  COUNTRY = 'country',
  CHECKBOX = 'checkbox',
  RADIO = 'radio'
}

export enum QuantityOrigin {
  Basket = 1,
  Product = 2,
  Modal = 3
}

export enum AppStores {
  AppStore = 1,
  PlayStore = 2,
  WebApp = 3
}

export enum AddressType {
  Shipping = 'shipping',
  Billing = 'billing',
  Installation = 'installation'
}

export enum ModalTab {
  Select = 1,
  Add = 2
}

export enum OrderStatus {
  Pending = 'Pending',
  BeingProcessed = 'Being processed',
  PartiallyShipped = 'Partially shipped',
  Shipped = 'Shipped',
  Delivered = 'Delivered',
  FailedPayment = 'Failed payment',
  CanceledByUser = 'Canceled by user',
  CanceledByFailedPayment = 'Canceled by failed payment',
  Refunded = 'Refunded'
}

export enum ShippingStatus {
  Pending = 'Pending',
  BeingProcessed = 'Being processed',
  Shipped = 'Shipped',
  Delivered = 'Delivered',
  Returned = 'Returned',
  Canceled = 'Canceled'
}

export enum ProductCategoryType {
  Category = 'category',
  Product = 'product',
  Search = 'search'
}

export enum OrderOrigin {
  ProductsPage = 'products_page',
  ProductComments = 'product_comments'
}

export enum ProductFeaturesCode {
  Plug = 'plug',
  MaxPower = 'max_power',
  Cable = 'cable',
  Meters = 'meters'
}

export enum CheckoutTab {
  Shipping = 1,
  Payment = 2,
  Summary = 3
}

export enum WalletType {
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export enum PaymentLogic {
  PrePayment = 'PRE_PAYMENT',
  PostPayment = 'POST_PAYMENT'
}

export enum FormTabEnum {
  Credentials = 1,
  PhoneNumber = 2,
  InfoValidation = 3
}
